import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from '@/App';
import { initLogging } from '@/features/logging/init-datadog';
import { setupStore } from '@/store/store';

(() => {
  const product = process.env.PRODUCT;
  if (product) {
    document.title = `${product.charAt(0).toUpperCase() + product.slice(1)} Game Client`;
  }
})();

initLogging();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={setupStore()}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
);
